import { log } from '@/shared/utils/log';

import { CollectionName } from '../../sj-orm/constants';
import { SJDatabase } from '../../sj-orm/core';

export const updatePublicKeysInDtos = async ({
  sjDb,
  dtoIdsMap,
  publicKey,
}: {
  sjDb: SJDatabase;
  dtoIdsMap: Map<CollectionName, string[]>;
  publicKey: string;
}) => {
  const updatePublicKeyPromises: Promise<boolean>[] = [];

  dtoIdsMap.forEach((dtoIds, collectionName) => {
    const collection = sjDb.collections[collectionName];

    if (!collection) {
      return;
    }

    dtoIds.forEach((dtoId) => {
      log.info('[col] putPublicKey', collection);

      const updatePublicKeyPromise = collection.putPublicKey(dtoId, publicKey);

      updatePublicKeyPromises.push(updatePublicKeyPromise);
    });
  });

  await Promise.all(updatePublicKeyPromises);
};
